import { isNil, isString } from 'lodash';
import { EditableField, Field } from './Field';

export interface Signature {
  url: string;
  contentType: string;
  name: string;
  height?: number;
  width?: number;
  date?: string;
  userId?: number;
}

export class SignatureField implements EditableField {
  readonly signature: Signature;
  readonly fieldType = 'SignatureField';

  constructor(signature: Signature) {
    this.signature = signature;
  }

  validate(): string | null {
    return null;
  }

  isEqual(field: Field): boolean {
    return field instanceof SignatureField && this.signature === field.signature;
  }

  toFieldJson() {
    return this.signature;
  }

  get isEmpty() {
    return isNil(this.signature.url);
  }

  static fromFieldJson(jsonBlob: any): SignatureField | null {
    if (isSignature(jsonBlob)) {
      return new SignatureField(jsonBlob);
    } else {
      return null;
    }
  }
}

function isSignature(jsonBlob: any): jsonBlob is Signature {
  return (
    !isNil(jsonBlob) &&
    isString(jsonBlob.url) &&
    isString(jsonBlob.contentType) &&
    isString(jsonBlob.name)
  );
}
